import { executeForCRUD } from '@/services/frontBack';

interface HeliosPermissionRow {
  Puede_Emitir?: unknown;
  puede_emitir?: unknown;
  PuedeEmitir?: unknown;
}

const normalizePermissionValue = (value: unknown): boolean => {
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') return value.trim() === '1';
  if (typeof value === 'boolean') return value;
  return false;
};

const canRowEmit = (row: unknown): boolean => {
  if (!row || typeof row !== 'object') return false;

  const permissionRow = row as HeliosPermissionRow;
  return (
    normalizePermissionValue(permissionRow.Puede_Emitir) ||
    normalizePermissionValue(permissionRow.puede_emitir) ||
    normalizePermissionValue(permissionRow.PuedeEmitir)
  );
};

/**
 * Obtiene permisos de emisión desde Helios_Autos_Permisos para el usuario.
 * Fail-closed: ante cualquier error o respuesta inválida retorna false.
 */
export const fetchCanEmitFromHelios = async (idUsuario: number): Promise<boolean> => {
  if (!Number.isFinite(idUsuario) || idUsuario <= 0) {
    return false;
  }

  try {
    const response = await executeForCRUD({
      ClassName: 'Helios_Autos_Permisos',
      Action: 'Get',
      Id_Usuario: idUsuario,
    });

    if (!response.success || !Array.isArray(response.data)) {
      return false;
    }

    return response.data.some((row) => canRowEmit(row));
  } catch {
    return false;
  }
};
